import {currentYear} from "./dateUtil";

export const CH_COPYRIGHTS = `© ${currentYear()} Creharmony.fr`;

export const GG_CATEGORY = {
    ADMIN: "ADMIN",
    MENU: "MENU",
    LISTING: "LISTING",
    AUTH: "AUTH",
    LEGAL: "LEGAL",
    OTHER: "OTHER"
};
